import { missionPLatField, missionPLngField } from '../../../utils/constants'


export const initialState = (page = {}) => ({
  id: page.id,
  lat: null,
  lon: null,
})

export const answerUpdate = (state = initialState(), payload) => ({
  ...state,
  lat: payload[missionPLatField(state)],
  lon: payload[missionPLngField(state)],
})

export default { initialState, answerUpdate }



// WEBPACK FOOTER //
// ./src/reducers/Missions/Answers/checkin.jsx